export default __webpack_public_path__ + "static/media/1766.b5f937d3.png";